import React, { Component } from 'react'
import { observer } from 'mobx-react'

import TeamsStore from '../../../stores/teams'
import api from '../../../api'

import TransferSelector from './transfer_selector'
import Icon from '../../util/Icon'

@observer
export default class Transfers extends Component {
  teams = new TeamsStore()

  state = {
    fromWebsite: null,
    toWebsite: null,
    copyHotsheets: false,
    copySettings: false,
    requesting: false,
    requested: false,
    ownerEmail: null,
  }

  componentDidMount() {
    this.teams.load()
  }

  handleFromWebsite = website => {
    this.setState({ fromWebsite: website ? website.id : null })
  }

  handleToWebsite = website => {
    this.setState({ 
      toWebsite: website ? website.id : null,
      toWebsiteName: website ? website.name : null,
    })
  }

  handleCopyHotsheets = event => {
    this.setState({ copyHotsheets: event.target.checked })
  }

  handleCopySettings = event => {
    this.setState({ copySettings: event.target.checked })
  }

  handleTransferRequest = event => {
    event.preventDefault()

    const confirmed = window.confirm('Are you sure you want to transfer? This cannot be undone.')

    if (confirmed) {
      this.setState({ requesting: true })
      const payload = {
        from_id: this.state.fromWebsite,
        to_id: this.state.toWebsite,
        transfer_hotsheets: this.state.copyHotsheets,
        transfer_settings: this.state.copySettings,
      }

      this.requestTransfer(payload).then(data => {
        this.setState({
          requesting: false,
          requested: true,
          ownerEmail: data.owner_email,
        })
      })
    }
  }

  async requestTransfer(payload) {
    const { data } = await api.post('transfer_requests', payload)
    await api.post(`transfer_requests/${data.id}/enqueue`)
    return data
  }

  renderSectionTwo() {
    const { fromWebsite, toWebsite, copyHotsheets, copySettings } = this.state
    if (fromWebsite && toWebsite) {
      return (
        <div className="transfer-options">
          <label>
            <input type="checkbox" checked={copyHotsheets} onChange={this.handleCopyHotsheets} />
            <span>Copy All Hotsheets</span>
          </label>

          <label>
            <input type="checkbox" checked={copySettings} onChange={this.handleCopySettings} />
            <span>Copy All Settings</span>
          </label>
        </div>
      )
    }
  }

  renderSectionThree() {
    const { fromWebsite, toWebsite, toWebsiteName, copyHotsheets, copySettings } = this.state
    if (fromWebsite && toWebsite && (copyHotsheets || copySettings)) {
      return (
        <div>
          <div className="panel padded danger">
            { copyHotsheets && (<p>
              <strong>Warning:</strong> Any existing hotsheets with the
              same name on <strong>{toWebsiteName}</strong> will be deleted. 
              This cannot be undone.
            </p>) }

            { copySettings && (<p>
              <strong>Warning:</strong> This will override all settings
              on <strong>{toWebsiteName}</strong>. This cannot be undone.
            </p>) }

            <button className="button danger" onClick={this.handleTransferRequest}>Confirm Transfer</button>
          </div>
        </div>
      )
    }
  }

  renderRequesting() {
    return (
      <div className="tansfer-requesting">
        <Icon className="fa-spin" icon="spinner" />
        <span>Requesting Transfer</span>
      </div>
    )
  }

  renderRequested() {
    return (
      <div className="tansfer-requested">
        <h2>Accepted</h2>
        Your transfer request was accepted. You will recieve an
        email at <strong>{this.state.ownerEmail}</strong> when it completes.
      </div>
    )
  }

  render() {
    if (!this.teams.loaded) return <div className="loading">Loading...</div>

    const { fromWebsite, toWebsite, requesting, requested } = this.state

    if (requesting) return this.renderRequesting()

    if (requested) return this.renderRequested()

    return (
      <div className="container padded transfers">
        <div className="panel full padded">
          <h2 className="title">Website Transfers</h2>

          <p className="transfer-description">
            Copy hotsheets and settings between websites.
            <br />
            The <strong>From</strong> website will <strong>not</strong> lose 
            any data. Data is only <strong>copied</strong> to 
            the <strong>To</strong> website.
          </p>

          <p style={{textAlign: 'center'}}></p>

          <div className="transfer-group">
            <TransferSelector
              teamStore={this.teams}
              title="From"
              excludeWebsites={toWebsite ? [toWebsite] : undefined}
              onWebsiteSelect={this.handleFromWebsite} />
            <Icon icon="arrow-right" />
            <TransferSelector
              teamStore={this.teams}
              title="To"
              excludeWebsites={fromWebsite ? [fromWebsite] : undefined}
              onWebsiteSelect={this.handleToWebsite} />
          </div>

          {this.renderSectionTwo()}
          {this.renderSectionThree()}

        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// client/components/sections/Transfers/index.js